import axios from 'axios';
import { baseUrl, HttpMethods } from '../../base';
import type {
  DeleteProjectTemplateService,
  DeleteProjectTemplateTdmService,
  GetProjectTemplateResponse,
  GetProjectTemplateService,
  GetProjectTemplatesResponse,
  GetProjectTemplatesService,
  GetProjectTemplateTdmService,
  IPatchProjectTemplateBulkTDMsService,
  IPutBulkProjectTemplateTdmService,
  IPutProjectTemplateTDMImportService,
  PatchProjectTemplateService,
  PatchProjectTemplateTdmService,
  PostNewProjectTemplateService,
  PostProjectTemplateTdmService,
  PutProjectTemplateTdmService,
} from './types';

const projectTemplateBasePath = `${baseUrl.SHERPA}/project_templates`;

//TO DO: Response type
export async function getProjectTemplates({ params }: GetProjectTemplatesService) {
  const res = await axios.request<{ data: GetProjectTemplatesResponse }>({
    method: HttpMethods.GET,
    url: `${projectTemplateBasePath}`,
    params,
  });
  return res.data;
}

export async function getProjectTemplate({ templateId }: GetProjectTemplateService) {
  const res = await axios.request<GetProjectTemplateResponse>({
    method: HttpMethods.GET,
    url: `${projectTemplateBasePath}/${templateId}`,
  });
  return res.data;
}

export async function postNewProjectTemplate({ data }: PostNewProjectTemplateService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${projectTemplateBasePath}`,
    data,
  });

  return res.data;
}

export async function patchProjectTemplate({ templateId, data }: PatchProjectTemplateService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${projectTemplateBasePath}/${templateId}`,
    data,
  });

  return res.data;
}

export async function deleteProjectTemplate({ templateId }: DeleteProjectTemplateService) {
  const res = await axios.request({
    method: HttpMethods.DELETE,
    url: `${projectTemplateBasePath}/${templateId}`,
  });
  return res.data;
}

export async function getProjectTemplateTdm({ templateId, params }: GetProjectTemplateTdmService) {
  const res = await axios.request<{ data: GetProjectTemplatesResponse }>({
    method: HttpMethods.GET,
    url: `${projectTemplateBasePath}/${templateId}/tdm`,
    params,
  });
  return res.data;
}

export async function postProjectTemplateTdm({ templateId, data }: PostProjectTemplateTdmService) {
  const res = await axios.request({
    method: HttpMethods.POST,
    url: `${projectTemplateBasePath}/${templateId}/tdm`,
    data,
  });
  return res.data;
}

export async function putProjectTemplateTdm({ templateId, data }: PutProjectTemplateTdmService) {
  const res = await axios.request({
    method: HttpMethods.PUT,
    url: `${projectTemplateBasePath}/${templateId}/tdm`,
    data,
  });
  return res.data;
}

export async function deleteProjectTemplateTdm({ templateId, data, tdmId }: DeleteProjectTemplateTdmService) {
  const res = await axios.request({
    method: HttpMethods.DELETE,
    url: `${projectTemplateBasePath}/${templateId}/tdm/${tdmId}`,
    data,
  });
  return res.data;
}

export async function patchProjectTemplateTdm({ templateId, tdmId, data }: PatchProjectTemplateTdmService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${projectTemplateBasePath}/${templateId}/tdm/${tdmId}`,
    data,
  });

  return res.data;
}

export async function putProjectTemplateTDMImport({ templateId, data }: IPutProjectTemplateTDMImportService) {
  const res = await axios.request({
    method: HttpMethods.PUT,
    url: `${projectTemplateBasePath}/${templateId}/tdm`,
    data,
  });

  return res.data;
}

export async function patchProjectTemplateBulkTDMs({ templateId, data }: IPatchProjectTemplateBulkTDMsService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${projectTemplateBasePath}/${templateId}/tdm`,
    data,
  });

  return res.data;
}

export async function putBulkProjectTemplateTdm({ templateId, data }: IPutBulkProjectTemplateTdmService) {
  const res = await axios.request({
    method: HttpMethods.PUT,
    url: `${projectTemplateBasePath}/${templateId}/bulk-tdm`,
    data,
  });
  return res.data;
}
